// Arabic strings for the auditsMaint area. Keyed by the English source text; {name} placeholders stay as-is.
export default {
  " (Finance Controller signed)": " (وقّع المراقب المالي)",
  " (added to the asset Book cost)": " (أُضيف إلى التكلفة الدفترية للأصل)",
  " ({pct}% of {cost})": " ({pct}% من {cost})",
  " - classified {classification}": " - صُنِّف {classification}",
  " Expense Repair Record {repair} created.": " تم إنشاء سجل إصلاح مصروف {repair}.",
  " Repair-or-Replace signal raised: replacement is recommended.": " صدر مؤشر الإصلاح أو الاستبدال: يوصى بالاستبدال.",
  " by {name}": " بواسطة {name}",
  " · about {n} a day": " · حوالي {n} يوميًا",
  " → replaced by {tag}": " ← استُبدل بـ {tag}",
  "#{n} due {date}": "#{n} مستحق في {date}",
  "(Finance decision)": "(قرار المالية)",
  "(from {system}).": "(من {system}).",
  "({n} left)": "(متبقٍ {n})",
  "*** [MASKED]": "*** [مخفي]",
  ", and the two asset records are linked to each other.": "، ويُربط سجلا الأصلين ببعضهما.",
  ", condition {condition}. Cumulative repair spend {spend}.": "، الحالة {condition}. إجمالي الإنفاق التراكمي على الإصلاح {spend}.",
  ", the successor goes": "، ويدخل الأصل البديل",
  "- set by Finance": "- تحدده المالية",
  ". A ticket will be sent there; the Repair Record and its cost arrive from {system}.": ". ستُرسل تذكرة إليه، ويصل سجل الإصلاح وتكلفته من {system}.",
  ". It cannot be changed or deleted.": ". لا يمكن تعديله أو حذفه.",
  "50% Signal": "مؤشر 50%",
  ": PM-due items are sent there as tickets (once each) and no native task is created.": ": تُرسل بنود الصيانة الوقائية المستحقة إليه كتذاكر (مرة واحدة لكل بند) ولا تُنشأ مهمة داخلية.",
  ">{pct}% Tolerance Breach": "تجاوز حد التفاوت >{pct}%",
  ">{pct}% USALI Threshold": "حد USALI >{pct}%",
  "A cost books an expensed Repair Record. Completing sets the next due date from the completion date.": "إدخال تكلفة يسجّل سجل إصلاح كمصروف. الإكمال يحدد موعد الاستحقاق التالي من تاريخ الإكمال.",
  "A native Repair Record will be created to track the repair cost.": "سيُنشأ سجل إصلاح داخلي لتتبع تكلفة الإصلاح.",
  "Above {threshold} threshold": "أعلى من حد {threshold}",
  "Accept par adjustment {item}": "قبول تعديل المستوى القياسي {item}",
  "Accept the count and adjust the book balance to it": "قبول العد وتعديل الرصيد الدفتري وفقًا له",
  "Accepted & adjusted": "مقبول ومعدَّل",
  "Accumulated Depreciation:": "الإهلاك المتراكم:",
  "Active Repair Records": "سجلات الإصلاح النشطة",
  "Active Repairs": "الإصلاحات النشطة",
  "Active Tickets": "التذاكر النشطة",
  "Active schedules": "الجداول النشطة",
  "Add Schedule": "إضافة جدول",
  "Affected Asset": "الأصل المتأثر",
  "Alert": "التنبيه",
  "Alert Date": "تاريخ التنبيه",
  "All Department Heads of the property": "جميع رؤساء الأقسام في العقار",
  "All Locations": "جميع المواقع",
  "All Priorities": "جميع الأولويات",
  "All discrepancies are resolved.": "تمت معالجة جميع الفروقات.",
  "All {n} asset of this Catalogue Item": "جميع الأصول ({n}) لهذا الصنف من الكتالوج",
  "All {n} assets of this Catalogue Item": "جميع الأصول ({n}) لهذا الصنف من الكتالوج",
  "Annually": "سنويًا",
  "Anti-Pencil-Whipping Active: Book balances masked from field counter recount sheets. Physical quantities must be counted independently before comparison.": "الحماية من العد الشكلي مفعّلة: الأرصدة الدفترية مخفية عن أوراق إعادة العد الميدانية. يجب عد الكميات الفعلية بشكل مستقل قبل المقارنة.",
  "Any location": "أي موقع",
  "Apply Resolution": "تطبيق المعالجة",
  "Apply resolution {tag}": "تطبيق المعالجة {tag}",
  "Approve Audit Reconciliation": "اعتماد تسوية الجرد",
  "Approve Reconciliation": "اعتماد التسوية",
  "Approve Relocation": "اعتماد النقل",
  "Approve Relocation {tag}": "اعتماد نقل {tag}",
  "Approve Write-off": "اعتماد الشطب",
  "Approve write-off for all low-value missing items (within the Book Policy threshold)?": "هل تريد اعتماد شطب جميع البنود المفقودة منخفضة القيمة (ضمن حد السياسة الدفترية)؟",
  "Are you sure you want to approve and close audit batch": "هل أنت متأكد من اعتماد وإغلاق دفعة الجرد",
  "As of": "حتى تاريخ",
  "Asset & Category": "الأصل والفئة",
  "Asset Condition Rating": "تقييم حالة الأصل",
  "Asset Name": "اسم الأصل",
  "Asset Repair History": "سجل إصلاحات الأصل",
  "Asset Replacement Queue": "قائمة استبدال الأصول",
  "Asset Tag & Name": "وسم الأصل واسمه",
  "Asset status:": "حالة الأصل:",
  "Asset tag, asset name or Catalogue Item": "وسم الأصل أو اسمه أو صنف الكتالوج",
  "Assets exceeding the 50% repair threshold, rated poor twice in 12 months, or recommended by a Linked Maintenance System for retirement and replacement.": "الأصول التي تجاوزت حد الإصلاح 50%، أو قُيّمت بحالة سيئة مرتين خلال 12 شهرًا، أو أوصى نظام صيانة مرتبط بإخراجها من الخدمة واستبدالها.",
  "Assign Technician": "تعيين فني",
  "Assign a team": "عيّن فريقًا",
  "Assign at least one team member": "عيّن عضوًا واحدًا على الأقل في الفريق",
  "Assigned Team": "الفريق المكلّف",
  "Assigned Tech": "الفني المكلّف",
  "Assigned team": "الفريق المكلّف",
  "Assigned to": "مكلّف إلى",
  "Attach at most {n} photos": "أرفق {n} صور كحد أقصى",
  "Audit Observation / Found At": "ملاحظة الجرد / موقع العثور",
  "Audit Reconciliation Console": "وحدة تسوية الجرد",
  "Audit Schedules & Coverage": "جداول الجرد والتغطية",
  "Audit Variance Report - {batch}": "تقرير فروقات الجرد - {batch}",
  "Audit Verification Rate": "نسبة التحقق في الجرد",
  "Audit batch": "دفعة الجرد",
  "Audit batch {batch} reconciled. The immutable variance report was generated and the batch is closed.": "تمت تسوية دفعة الجرد {batch}. أُنشئ تقرير الفروقات غير القابل للتعديل وأُغلقت الدفعة.",
  "Audit schedules": "جداول الجرد",
  "Audit type": "نوع الجرد",
  "Audited": "تم جرده",
  "Auditor Notes & Certified Sign-off": "ملاحظات المدقق والاعتماد الموثّق",
  "Auto-Fill Tag": "تعبئة الوسم تلقائيًا",
  "Auto-Generate Repair Work Order": "إنشاء أمر عمل إصلاح تلقائيًا",
  "Auto-Relocate Misplaced ({n})": "نقل الأصول في غير موقعها تلقائيًا ({n})",
  "Auto-expensed as shrinkage": "يُحمَّل تلقائيًا كفاقد",
  "Avg Cycle MTTR": "متوسط زمن الإصلاح",
  "Awaiting Finance Controller": "بانتظار المراقب المالي",
  "Awaiting Finance Controller:": "بانتظار المراقب المالي:",
  "Awaiting assignment": "بانتظار التعيين",
  "Awaiting resolution": "بانتظار المعالجة",
  "Back of house": "المناطق الخلفية",
  "Batch": "الدفعة",
  "Batch Quick-Actions:": "إجراءات سريعة للدفعة:",
  "Bulk Write-off Within Threshold": "شطب جماعي ضمن الحد",
  "Cadence": "التكرار",
  "Calculate & Reveal Variances": "احتساب الفروقات وإظهارها",
  "Calendar": "تقويمي",
  "Capitalised": "مرسمل",
  "Catalogue Item": "صنف الكتالوج",
  "Certification remarks": "ملاحظات الاعتماد",
  "Certified remarks: physical count completed; missing assets verified through blind recount and submitted for controller disposal sign-off.": "ملاحظات معتمدة: اكتمل العد الفعلي؛ تم التحقق من الأصول المفقودة عبر إعادة العد الأعمى وإرسالها لاعتماد الاستبعاد من المراقب.",
  "Certify & Approve Batch": "اعتماد الدفعة والمصادقة عليها",
  "Check as at": "الفحص حتى تاريخ",
  "Check refrigerant pressure\nClean condenser coil": "فحص ضغط غاز التبريد\nتنظيف ملف المكثف",
  "Checklist (one item per line)": "قائمة التحقق (بند في كل سطر)",
  "Choose the Catalogue Item of the successor": "اختر صنف الكتالوج للأصل البديل",
  "Choose the asset or Catalogue Item the schedule applies to": "اختر الأصل أو صنف الكتالوج الذي ينطبق عليه الجدول",
  "Choose the first due date": "اختر تاريخ الاستحقاق الأول",
  "Clear Filters": "مسح عوامل التصفية",
  "Close the audit batch decision in the reconciliation console": "أغلق قرار دفعة الجرد من وحدة التسوية",
  "Complete PM": "إكمال الصيانة الوقائية",
  "Complete PM {task}": "إكمال الصيانة الوقائية {task}",
  "Complete Repair & Restore in_service": "إكمال الإصلاح وإعادة الأصل إلى الخدمة",
  "Completed On": "تاريخ الإكمال",
  "Completed: total {total}, classified {classification}": "مكتمل: الإجمالي {total}، صُنِّف {classification}",
  "Condition Damaged": "الحالة: تالف",
  "Condition noted": "تم تسجيل الحالة",
  "Condition recorded for corrective maintenance": "سُجّلت الحالة للصيانة التصحيحية",
  "Confirm & Execute Replacement": "تأكيد وتنفيذ الاستبدال",
  "Contractor handover": "تسليم المقاول",
  "Contractor invoice": "فاتورة المقاول",
  "Contractor invoice reference": "مرجع فاتورة المقاول",
  "Contractor name": "اسم المقاول",
  "Controller Variance Approval Required": "يلزم اعتماد المراقب للفرق",
  "Cost ({currency})": "التكلفة ({currency})",
  "Cost Classification (Book Policy)": "تصنيف التكلفة (السياسة الدفترية)",
  "Cost Net of Recoverable VAT ({currency})": "التكلفة بعد خصم ضريبة القيمة المضافة القابلة للاسترداد ({currency})",
  "Cost must be zero or more": "يجب أن تكون التكلفة صفرًا أو أكثر",
  "Could not read {file}": "تعذّرت قراءة {file}",
  "Coverage": "التغطية",
  "Create Schedule": "إنشاء الجدول",
  "Create audit schedule": "إنشاء جدول جرد",
  "Credit (AED)": "دائن (درهم)",
  "Cumul. Repair ({currency})": "الإصلاح التراكمي ({currency})",
  "Cumulative Repairs:": "الإصلاحات التراكمية:",
  "Cumulative with this repair:": "الإجمالي التراكمي مع هذا الإصلاح:",
  "Current cycle": "الدورة الحالية",
  "Cycle": "الدورة",
  "Cycle coverage": "تغطية الدورة",
  "Cycles": "الدورات",
  "Damage photo of {tag}": "صورة الضرر لـ {tag}",
  "Days": "أيام",
  "Days overdue": "أيام التأخير",
  "Deactivate": "إيقاف",
  "Debit (AED)": "مدين (درهم)",
  "Decision notes (optional)": "ملاحظات القرار (اختياري)",
  "Defect & Details": "العطل والتفاصيل",
  "Defect Photos": "صور العطل",
  "Defect Summary": "ملخص العطل",
  "Defect photos": "صور العطل",
  "Delivery failed - retried on the next check": "فشل الإرسال - ستُعاد المحاولة في الفحص التالي",
  "Describe the defect (at least 5 characters)": "صف العطل (5 أحرف على الأقل)",
  "Describe the maintenance task (at least 3 characters)": "صف مهمة الصيانة (3 أحرف على الأقل)",
  "Detailed Symptoms": "الأعراض بالتفصيل",
  "Discrepancies": "الفروقات",
  "Dismissed": "مرفوض",
  "Dispatch Work Order: log the damage as a maintenance incident": "إصدار أمر عمل: تسجيل الضرر كحادثة صيانة",
  "Dispatch work order {tag}": "إصدار أمر عمل {tag}",
  "Disposal": "الاستبعاد",
  "Disposal Method": "طريقة الاستبعاد",
  "Done {date}": "أُنجز في {date}",
  "Due": "الاستحقاق",
  "Due by": "الاستحقاق حسب",
  "Due preventive maintenance to complete with notes, photo and cost.": "الصيانة الوقائية المستحقة لإكمالها مع الملاحظات والصورة والتكلفة.",
  "Due when the meter reaches the next service point, or at the calendar interval below, whichever comes first.": "تستحق عندما يصل العداد إلى نقطة الخدمة التالية، أو عند الفترة الزمنية أدناه، أيهما أسبق.",
  "Each due PM is sent once to the linked system; completion is reported back by it.": "تُرسل كل صيانة وقائية مستحقة مرة واحدة إلى النظام المرتبط، وهو يُبلغ عن إكمالها.",
  "Engineering & Maintenance": "الهندسة والصيانة",
  "Enter a schedule name": "أدخل اسم الجدول",
  "Enter an asset tag or item name to search": "أدخل وسم الأصل أو اسم الصنف للبحث",
  "Enter an investigation note (at least 3 characters).": "أدخل ملاحظة التحقيق (3 أحرف على الأقل).",
  "Enter how many hours or cycles between services": "أدخل عدد الساعات أو الدورات بين كل خدمة",
  "Enter the assigned team": "أدخل الفريق المكلّف",
  "Enter the contractor name or invoice reference": "أدخل اسم المقاول أو مرجع الفاتورة",
  "Enter the cost net of recoverable VAT": "أدخل التكلفة بعد خصم ضريبة القيمة المضافة القابلة للاسترداد",
  "Enter the hourly rate": "أدخل أجر الساعة",
  "Enter the meter reading": "أدخل قراءة العداد",
  "Enter the proceeds realised (zero or more)": "أدخل المتحصلات المحققة (صفر أو أكثر)",
  "Enter the repair cost as a non-negative amount": "أدخل تكلفة الإصلاح كمبلغ غير سالب",
  "Enter the successor item name": "أدخل اسم الصنف البديل",
  "Equipment": "المعدة",
  "Equipment / Item": "المعدة / الصنف",
  "Equipment / Item Model": "المعدة / طراز الصنف",
  "Evaluate coverage as of": "تقييم التغطية حتى تاريخ",
  "Evaluated as of {asOf}: {opened} new cycle(s) opened, {overdue} cycle(s) with overdue audits, {sent} notification(s) sent to the assigned team and Department Head.": "تم التقييم حتى {asOf}: فُتحت {opened} دورة جديدة، و{overdue} دورة بها عمليات جرد متأخرة، وأُرسل {sent} إشعار إلى الفريق المكلّف ورئيس القسم.",
  "Every": "كل",
  "Every 6 months": "كل 6 أشهر",
  "Everything audits, counts and returns flagged - missing, damaged, extra and mislocated items, and stock counted over or under book - with its value. Resolve each one as found, moved, written off, repaired or replaced.": "كل ما رصدته عمليات الجرد والعد والإرجاع - البنود المفقودة والتالفة والزائدة وفي غير موقعها، والمخزون المعدود بأكثر أو أقل من الدفاتر - مع قيمته. عالج كل بند كموجود أو منقول أو مشطوب أو مُصلَح أو مستبدَل.",
  "Exception Investigation - {tag}": "التحقيق في الاستثناء - {tag}",
  "Exception Queue": "قائمة الاستثناءات",
  "Exception investigation open": "التحقيق في الاستثناء مفتوح",
  "Exception investigation recorded for {tag}.": "تم تسجيل التحقيق في الاستثناء لـ {tag}.",
  "Execute Asset Replacement": "تنفيذ استبدال الأصل",
  "Execute Replacement": "تنفيذ الاستبدال",
  "Execute bulk location updates for all {n} misplaced assets to their physically scanned locations?": "هل تريد تحديث مواقع جميع الأصول الموجودة في غير موقعها ({n}) إلى المواقع التي مُسحت فيها فعليًا؟",
  "Expected": "المتوقع",
  "Expected Book Par": "المستوى الدفتري المتوقع",
  "Expected Location": "الموقع المتوقع",
  "Expensed": "مصروف",
  "Expensed, unless Finance flags the repair as life-extending and its cost is at or above the category capitalisation threshold.": "يُعامل كمصروف، ما لم تحدد المالية أن الإصلاح يطيل العمر وتكون تكلفته عند حد الرسملة للفئة أو أعلى منه.",
  "Expired {date}": "انتهى في {date}",
  "Expiring in {n} Days (Alert!)": "ينتهي خلال {n} يومًا (تنبيه!)",
  "Export": "تصدير",
  "Extra": "زائد",
  "Fair (Operational, Monitor)": "مقبول (يعمل، يحتاج متابعة)",
  "Finalize & Post Batch": "إنهاء الدفعة وترحيلها",
  "Finance Controller Sign-off - {tag}": "اعتماد المراقب المالي - {tag}",
  "Financial Impact & General Ledger Reconciliation Summary": "الأثر المالي وملخص تسوية دفتر الأستاذ العام",
  "Financial cost fields are locked. Costs flow strictly from the linked maintenance system ticket to avoid double-counting.": "حقول التكلفة المالية مقفلة. تأتي التكاليف حصرًا من تذكرة نظام الصيانة المرتبط لتجنب الاحتساب المزدوج.",
  "Find an asset to record a reading. Readings never go down; each one is checked against the asset's meter-based schedules.": "ابحث عن أصل لتسجيل قراءة. القراءات لا تنخفض أبدًا، وتُقارن كل قراءة بجداول الصيانة المبنية على العداد لذلك الأصل.",
  "First due date": "تاريخ الاستحقاق الأول",
  "Fixed Assets - FF&E at Cost": "الأصول الثابتة - الأثاث والتجهيزات بالتكلفة",
  "Floors": "الطوابق",
  "Found": "موجود",
  "Found / confirmed - no change to the register": "موجود / مؤكد - دون تغيير في السجل",
  "Found At": "موقع العثور",
  "Found in other rooms": "وُجدت في غرف أخرى",
  "Found in {location}": "وُجد في {location}",
  "Frequency": "التكرار",
  "Good (Operational)": "جيد (يعمل)",
  "Guest rooms": "غرف النزلاء",
  "Handover": "تسليم",
  "Handover of": "تسليم",
  "Hidden until variances are revealed": "مخفي حتى إظهار الفروقات",
  "Hold this line for investigation (stock is not adjusted)": "تعليق هذا البند للتحقيق (دون تعديل المخزون)",
  "Hospitality Par Variances": "فروقات المستوى القياسي للضيافة",
  "Hospitality Tolerance Status": "حالة تفاوت الضيافة",
  "Hospitality rule: Variances exceeding {pct}% require controller review; ≤{pct}% auto-reconcile as shrinkage": "قاعدة الضيافة: الفروقات التي تتجاوز {pct}% تتطلب مراجعة المراقب؛ و≤{pct}% تُسوّى تلقائيًا كفاقد",
  "Hotel Property": "الفندق",
  "Hourly labour rate": "أجر العمل بالساعة",
  "I certify that physical counts and variances have been verified according to hospitality accounting policies.": "أشهد بأنه تم التحقق من العد الفعلي والفروقات وفقًا للسياسات المحاسبية للضيافة.",
  "Immediate guest impact": "تأثير فوري على النزلاء",
  "Immutable report generated {date}": "تقرير غير قابل للتعديل أُنشئ في {date}",
  "In Progress": "قيد التنفيذ",
  "In progress at this property": "قيد التنفيذ في هذا العقار",
  "Incident Details": "تفاصيل الحادثة",
  "Inherited Location": "الموقع الموروث",
  "Interval must be a whole number of at least 1": "يجب أن تكون الفترة عددًا صحيحًا لا يقل عن 1",
  "Investigation note": "ملاحظة التحقيق",
  "Invoice ref": "مرجع الفاتورة",
  "Issue Title": "عنوان المشكلة",
  "Journal covers approved and pending asset write-offs ({total} D/C, balanced). Posts to ERP on controller sign-off.": "يغطي القيد عمليات شطب الأصول المعتمدة والمعلّقة ({total} مدين/دائن، متوازن). يُرحَّل إلى نظام ERP عند اعتماد المراقب.",
  "Keep the summary under 160 characters": "اجعل الملخص أقل من 160 حرفًا",
  "Labor + Parts Expense": "مصروف العمالة وقطع الغيار",
  "Labour hours": "ساعات العمل",
  "Labour rate": "أجر العمل",
  "Last Done": "آخر تنفيذ",
  "Last Executed": "آخر تنفيذ",
  "Last service at": "آخر خدمة عند",
  "Leave all unchecked to use the audit type default.": "اترك الكل دون تحديد لاستخدام الافتراضي لنوع الجرد.",
  "Leave empty to include the whole property.": "اتركه فارغًا لتضمين العقار بالكامل.",
  "Life-extending repair": "إصلاح يطيل العمر",
  "Linked Maintenance System": "نظام الصيانة المرتبط",
  "Linked: {system}": "مرتبط: {system}",
  "Loading photo...": "جارٍ تحميل الصورة...",
  "Loading repair records...": "جارٍ تحميل سجلات الإصلاح...",
  "Loading…": "جارٍ التحميل…",
  "Location / Room": "الموقع / الغرفة",
  "Location records re-assigned on approval": "يُعاد تعيين سجلات المواقع عند الاعتماد",
  "Location types": "أنواع المواقع",
  "Location updated": "تم تحديث الموقع",
  "Location:": "الموقع:",
  "Loss on Fixed Asset Shrinkage & Missing": "خسارة فاقد وفقدان الأصول الثابتة",
  "Low": "منخفضة",
  "Maintenance & Repairs Workbench": "منصة الصيانة والإصلاحات",
  "Maintenance Incident Logging": "تسجيل حوادث الصيانة",
  "Maintenance Link Mode:": "وضع ربط الصيانة:",
  "Maintenance Operations": "عمليات الصيانة",
  "Maintenance Task Description": "وصف مهمة الصيانة",
  "Manage repair records, replacement signals, asset replacements and preventive maintenance schedules.": "إدارة سجلات الإصلاح ومؤشرات الاستبدال واستبدال الأصول وجداول الصيانة الوقائية.",
  "Mark Resolved": "تعليم كمحلولة",
  "Meter": "العداد",
  "Meter Readings": "قراءات العداد",
  "Meter reached {reading} {unit}": "وصل العداد إلى {reading} {unit}",
  "Meter reading": "قراءة العداد",
  "Meter-based maintenance": "الصيانة حسب العداد",
  "Misplaced": "في غير موقعه",
  "Misplaced & Auto-Located": "في غير موقعه ومحدد تلقائيًا",
  "Missing Assets Variance": "فرق الأصول المفقودة",
  "Monthly": "شهريًا",
  "Months": "أشهر",
  "Moved": "منقول",
  "Moved - the register follows where it was found": "منقول - يُحدَّث السجل حسب موقع العثور",
  "Native corrective maintenance logging with the Repair-or-Replace threshold evaluation.": "تسجيل الصيانة التصحيحية داخليًا مع تقييم حد الإصلاح أو الاستبدال.",
  "Net Book Value": "صافي القيمة الدفترية",
  "Net Book Value (NBV):": "صافي القيمة الدفترية (NBV):",
  "New (Like new)": "جديد (كالجديد)",
  "New PM Schedule": "جدول صيانة وقائية جديد",
  "New Preventive Maintenance Schedule": "جدول صيانة وقائية جديد",
  "New Scannable Asset Tag (ULID / Short Code)": "وسم أصل جديد قابل للمسح (ULID / رمز قصير)",
  "New Schedule": "جدول جديد",
  "Next Due Date": "تاريخ الاستحقاق التالي",
  "Next due at": "الاستحقاق التالي عند",
  "No PM tasks are due.": "لا توجد مهام صيانة وقائية مستحقة.",
  "No PM tickets have been sent yet.": "لم تُرسل أي تذاكر صيانة وقائية بعد.",
  "No assets currently carry a Repair-or-Replace signal.": "لا توجد أصول تحمل حاليًا مؤشر الإصلاح أو الاستبدال.",
  "No audit batches": "لا توجد دفعات جرد",
  "No audit batches are available yet. Batches appear here once an audit walk has been scheduled.": "لا توجد دفعات جرد بعد. تظهر الدفعات هنا بمجرد جدولة جولة جرد.",
  "No audit cycles generated yet.": "لم تُنشأ دورات جرد بعد.",
  "No audit schedules yet.": "لا توجد جداول جرد بعد.",
  "No discrepancies match this view.": "لا توجد فروقات مطابقة لهذا العرض.",
  "No gain or loss": "لا ربح ولا خسارة",
  "No incidents found.": "لم يتم العثور على حوادث.",
  "No meter-based schedule for this asset. Add one under Preventive Maintenance and choose \"Meter reading\".": "لا يوجد جدول مبني على العداد لهذا الأصل. أضف جدولًا من الصيانة الوقائية واختر \"قراءة العداد\".",
  "No open exceptions. Exceptions appear here as soon as an audit walk, a stock count or a custody return flags something.": "لا توجد استثناءات مفتوحة. تظهر الاستثناءات هنا فور رصدها في جولة جرد أو عد مخزون أو إرجاع عهدة.",
  "No overdue audits.": "لا توجد عمليات جرد متأخرة.",
  "No pooled supply lines are tracked for this property.": "لا توجد بنود مستلزمات مجمّعة متتبعة لهذا العقار.",
  "No preventive maintenance schedules are configured for this property yet.": "لم تُعدّ جداول صيانة وقائية لهذا العقار بعد.",
  "No readings yet.": "لا توجد قراءات بعد.",
  "No repair records found.": "لم يتم العثور على سجلات إصلاح.",
  "No replacements have been executed yet.": "لم يُنفَّذ أي استبدال بعد.",
  "No reportable asset matched. Check the tag or room.": "لا يوجد أصل مطابق قابل للإبلاغ. تحقق من الوسم أو الغرفة.",
  "No warranty alerts have been raised.": "لم تصدر أي تنبيهات ضمان.",
  "No warranty recorded": "لا يوجد ضمان مسجل",
  "Normal (guest room defect)": "عادية (عطل في غرفة نزيل)",
  "Not due": "غير مستحق",
  "Not located in room": "غير موجود في الغرفة",
  "Not recorded": "غير مسجل",
  "Note": "ملاحظة",
  "Note (optional)": "ملاحظة (اختياري)",
  "Nothing changes until you execute the replacement and the disposal is approved.": "لا يتغير شيء حتى تنفذ الاستبدال ويُعتمد الاستبعاد.",
  "Nothing matches these filters.": "لا توجد نتائج مطابقة لعوامل التصفية هذه.",
  "Nothing matches.": "لا توجد نتائج مطابقة.",
  "On approval of the disposal: the old asset is marked": "عند اعتماد الاستبعاد: يُعلَّم الأصل القديم",
  "On track": "في المسار",
  "Only Department Heads and managers can define PM schedules": "يمكن لرؤساء الأقسام والمديرين فقط تحديد جداول الصيانة الوقائية",
  "Open Exception Investigation": "فتح تحقيق في الاستثناء",
  "Open cycles": "الدورات المفتوحة",
  "Open value:": "القيمة المفتوحة:",
  "Open-cycle coverage": "تغطية الدورات المفتوحة",
  "Operating Item & Category": "صنف التشغيل والفئة",
  "Operating Supplies & Linen Blind Par Reconciliation (USALI {pct}% Tolerance Benchmark)": "تسوية المستوى القياسي الأعمى لمستلزمات التشغيل والبياضات (معيار تفاوت USALI {pct}%)",
  "Optional": "اختياري",
  "Or every": "أو كل",
  "Outlet": "منفذ",
  "Outstanding discrepancies:": "الفروقات المعلّقة:",
  "Over-par": "أعلى من المستوى القياسي",
  "Overdue audits": "عمليات الجرد المتأخرة",
  "Overdue escalation (Department Head)": "التصعيد عند التأخير (رئيس القسم)",
  "Overdue only": "المتأخرة فقط",
  "Overdue {n} day": "متأخر {n} يوم",
  "Overdue {n} days": "متأخر {n} أيام",
  "Owner handover": "تسليم المالك",
  "PM Schedules": "جداول الصيانة الوقائية",
  "PM Task List": "قائمة مهام الصيانة الوقائية",
  "PM Tasks Due": "مهام الصيانة الوقائية المستحقة",
  "PM check as at {asOf}: {tasks} task(s) added, {tickets} ticket(s) sent to the linked system, {alerts} warranty alert(s) raised.": "فحص الصيانة الوقائية حتى {asOf}: أُضيفت {tasks} مهمة، وأُرسلت {tickets} تذكرة إلى النظام المرتبط، وصدر {alerts} تنبيه ضمان.",
  "PM schedule for {target} deactivated.": "تم إيقاف جدول الصيانة الوقائية لـ {target}.",
  "PM schedule saved for {target}: {cadence}, next due {due}.": "تم حفظ جدول الصيانة الوقائية لـ {target}: {cadence}، الاستحقاق التالي {due}.",
  "PM tasks exported as {format}.": "تم تصدير مهام الصيانة الوقائية بصيغة {format}.",
  "PM-due Tickets sent to {system}": "تذاكر الصيانة الوقائية المرسلة إلى {system}",
  "Page {page} of {pages}": "الصفحة {page} من {pages}",
  "Page {page} of {pages} ({total} discrepancies)": "الصفحة {page} من {pages} ({total} فرق)",
  "Parts & Materials Invoiced ({currency})": "قطع الغيار والمواد المفوترة ({currency})",
  "Parts cost": "تكلفة قطع الغيار",
  "Parts purchase expense (not physical inventory decrement).": "مصروف شراء قطع الغيار (دون خصم من المخزون الفعلي).",
  "Pause": "إيقاف مؤقت",
  "Paused": "متوقف مؤقتًا",
  "Pending Tech": "بانتظار فني",
  "Pending approval": "بانتظار الاعتماد",
  "Per asset": "لكل أصل",
  "Photos": "الصور",
  "Photos must be JPEG, PNG or WebP images": "يجب أن تكون الصور بصيغة JPEG أو PNG أو WebP",
  "Physical recount values revealed and variances calculated against book par balances.": "تم إظهار قيم إعادة العد الفعلي واحتساب الفروقات مقابل الأرصدة الدفترية القياسية.",
  "Physically Return to Expected Room": "إرجاع فعلي إلى الغرفة المتوقعة",
  "Please certify and check the confirmation box before finalizing.": "يرجى الاعتماد وتحديد مربع التأكيد قبل الإنهاء.",
  "Poor (Degraded)": "سيئ (متدهور)",
  "Preventive Maintenance & Warranty Tracking": "الصيانة الوقائية وتتبع الضمان",
  "Preventive maintenance cycles": "دورات الصيانة الوقائية",
  "Priority": "الأولوية",
  "Proactive Warranty Expiry Alerts:": "تنبيهات استباقية لانتهاء الضمان:",
  "Proceeds Realised ({currency})": "المتحصلات المحققة ({currency})",
  "Progress saved on {repair}.": "تم حفظ التقدم في {repair}.",
  "Proposed": "مقترح",
  "Proposed Resolution": "المعالجة المقترحة",
  "Proposed by {system}": "مقترح من {system}",
  "Public areas / outlets": "المناطق العامة / المنافذ",
  "Quarterly": "ربع سنوي",
  "Quarterly descaling, gasket seal inspection and burner calibration.": "إزالة الترسبات ربع السنوية، وفحص الحشوات، ومعايرة الموقد.",
  "Raised": "تاريخ الرصد",
  "Raised 60 and 14 days before a warranty lapses and sent to the Department Head.": "تصدر قبل انتهاء الضمان بـ 60 و14 يومًا وتُرسل إلى رئيس القسم.",
  "Rated poor twice in 12 months": "قُيّم بحالة سيئة مرتين خلال 12 شهرًا",
  "Read on": "تاريخ القراءة",
  "Read-only": "للقراءة فقط",
  "Reading": "القراءة",
  "Reading saved.": "تم حفظ القراءة.",
  "Reading saved. Preventive maintenance is now due: {tasks}.": "تم حفظ القراءة. الصيانة الوقائية مستحقة الآن: {tasks}.",
  "Readings ({n})": "القراءات ({n})",
  "Reconcile physical counts against the book, run blind recounts and review tolerance variances.": "سوِّ العد الفعلي مقابل الدفاتر، وأجرِ إعادة العد الأعمى، وراجع فروقات التفاوت.",
  "Reconciled": "تمت التسوية",
  "Reconciliation Ledger Journal Preview (USALI Format)": "معاينة قيد التسوية في دفتر الأستاذ (صيغة USALI)",
  "Record #": "رقم السجل",
  "Record cost": "تسجيل التكلفة",
  "Recorded": "مسجّل",
  "Recount Physical": "إعادة العد الفعلي",
  "Recount {item}": "إعادة عد {item}",
  "Recurring maintenance schedules and proactive warranty expiration management.": "جداول الصيانة الدورية والإدارة الاستباقية لانتهاء الضمان.",
  "Refresh": "تحديث",
  "Relocation awaiting approval": "النقل بانتظار الاعتماد",
  "Remaining": "المتبقي",
  "Remove {file}": "إزالة {file}",
  "Repair Cost ({currency})": "تكلفة الإصلاح ({currency})",
  "Repair Cost Capture ({currency})": "تسجيل تكلفة الإصلاح ({currency})",
  "Repair Record": "سجل الإصلاح",
  "Repair Record Workbench": "منصة سجل الإصلاح",
  "Repair Records": "سجلات الإصلاح",
  "Repair Records exported as {format}.": "تم تصدير سجلات الإصلاح بصيغة {format}.",
  "Repair Spend MTD": "إنفاق الإصلاح منذ بداية الشهر",
  "Repair Status": "حالة الإصلاح",
  "Repair cost": "تكلفة الإصلاح",
  "Repair cost recorded.": "تم تسجيل تكلفة الإصلاح.",
  "Repair record {ref}": "سجل الإصلاح {ref}",
  "Repair work orders and salvage retirement are handled in Maintenance & Work Orders.": "تتم معالجة أوامر عمل الإصلاح والإخراج للخردة في الصيانة وأوامر العمل.",
  "Repair-or-Replace share of replacement cost reached": "تم بلوغ نسبة الإصلاح أو الاستبدال من تكلفة الاستبدال",
  "Repaired": "مُصلَح",
  "Repaired - linked to its repair record": "مُصلَح - مرتبط بسجل الإصلاح",
  "Replace": "استبدال",
  "Replaced": "مستبدَل",
  "Replaced starter capacitor and tested thermal efficiency.": "تم استبدال مكثف التشغيل واختبار الكفاءة الحرارية.",
  "Replacement": "الاستبدال",
  "Replacement Cost:": "تكلفة الاستبدال:",
  "Replacement Recommended": "يوصى بالاستبدال",
  "Replacement Signal": "مؤشر استبدال",
  "Replacements": "الاستبدالات",
  "Report Defect / Log Incident": "الإبلاغ عن عطل / تسجيل حادثة",
  "Report a defect": "الإبلاغ عن عطل",
  "Report malfunctioning assets, triage defect severity, and dispatch engineering work orders.": "أبلغ عن الأصول المعطلة، وصنّف خطورة الأعطال، وأصدر أوامر العمل الهندسية.",
  "Report to resolution": "من البلاغ حتى الحل",
  "Reported By": "المُبلِّغ",
  "Reported By:": "المُبلِّغ:",
  "Reported Issue:": "المشكلة المُبلَّغ عنها:",
  "Reported in poor condition": "أُبلغ عنه بحالة سيئة",
  "Reported:": "تاريخ البلاغ:",
  "Resolution": "المعالجة",
  "Resolution & Status": "المعالجة والحالة",
  "Resolution for {item}": "المعالجة لـ {item}",
  "Resolution note": "ملاحظة المعالجة",
  "Resolve": "معالجة",
  "Resolved": "تمت المعالجة",
  "Resolved & Return to Service": "تمت المعالجة والإعادة إلى الخدمة",
  "Resume": "استئناف",
  "Retire to Salvage Storeroom": "إخراج إلى مخزن الخردة",
  "Retired asset": "الأصل المُخرَج",
  "Retiring Asset:": "الأصل المُخرَج:",
  "Return to expected room": "الإرجاع إلى الغرفة المتوقعة",
  "Review Sign-off": "مراجعة الاعتماد",
  "Review breach {item}": "مراجعة التجاوز {item}",
  "Room": "غرفة",
  "Run Overdue Check": "تشغيل فحص التأخير",
  "Run PM Check": "تشغيل فحص الصيانة الوقائية",
  "Running hours": "ساعات التشغيل",
  "Running hours and cycles of engineering and kitchen equipment. Meter-based maintenance falls due when the reading reaches the next service point.": "ساعات التشغيل والدورات لمعدات الهندسة والمطبخ. تستحق الصيانة المبنية على العداد عندما تصل القراءة إلى نقطة الخدمة التالية.",
  "Running...": "جارٍ التشغيل...",
  "Sale (Salvage Proceeds)": "بيع (متحصلات الخردة)",
  "Save Investigation Note": "حفظ ملاحظة التحقيق",
  "Save PM Schedule": "حفظ جدول الصيانة الوقائية",
  "Save Progress": "حفظ التقدم",
  "Save reading": "حفظ القراءة",
  "Scan or type an asset tag, or choose the room, then use Auto-Fill Tag.": "امسح وسم الأصل أو اكتبه، أو اختر الغرفة، ثم استخدم تعبئة الوسم تلقائيًا.",
  "Scan the new asset tag or enter its short code": "امسح وسم الأصل الجديد أو أدخل رمزه القصير",
  "Schedule": "الجدول",
  "Schedule \"{name}\" created. {total} audit tasks were generated for cycle 1, due {due}.": "تم إنشاء الجدول \"{name}\". أُنشئت {total} مهمة جرد للدورة 1، مستحقة في {due}.",
  "Schedule name": "اسم الجدول",
  "Schedule recurring physical audits, assign field teams and track coverage and overdue audits.": "جدوِل عمليات الجرد الفعلي الدورية، وكلّف الفرق الميدانية، وتابع التغطية وعمليات الجرد المتأخرة.",
  "Schedule type": "نوع الجدول",
  "Scrap (Zero Proceeds - Derecognise Loss)": "خردة (بدون متحصلات - إلغاء الاعتراف بالخسارة)",
  "Search WO#, asset, defect...": "ابحث برقم أمر العمل أو الأصل أو العطل...",
  "Search asset tag or name (for example a chiller, combi oven or dishwasher)": "ابحث بوسم الأصل أو اسمه (مثل مبرد مياه أو فرن متعدد أو غسالة صحون)",
  "Search discrepancies": "البحث في الفروقات",
  "Search record, tag, issue...": "ابحث بالسجل أو الوسم أو المشكلة...",
  "Search repair records": "البحث في سجلات الإصلاح",
  "Search tag, model...": "ابحث بالوسم أو الطراز...",
  "Select a Catalogue Item...": "اختر صنفًا من الكتالوج...",
  "Sent to linked system": "أُرسل إلى النظام المرتبط",
  "Serialized Fixed Asset Discrepancies ({n})": "فروقات الأصول الثابتة المسلسلة ({n})",
  "Shift handover": "تسليم المناوبة",
  "Showing 0 incidents": "عرض 0 حادثة",
  "Showing the first {shown} of {total} overdue audits.": "عرض أول {shown} من {total} عملية جرد متأخرة.",
  "Showing {from}-{to} of {total} incidents": "عرض {from}-{to} من {total} حادثة",
  "Spot Check": "فحص مفاجئ",
  "Standalone Property — native Repair Records active. Native repair costs captured in {currency} (labor, parts expense, contractor invoices).": "عقار مستقل — سجلات الإصلاح الداخلية مفعّلة. تُسجَّل تكاليف الإصلاح داخليًا بعملة {currency} (العمالة ومصروف قطع الغيار وفواتير المقاولين).",
  "State": "الحالة",
  "Step 1: Derecognise Old Asset (IAS 16 Disposal)": "الخطوة 1: إلغاء الاعتراف بالأصل القديم (استبعاد وفق IAS 16)",
  "Step 2: Register Successor Asset in Same Location": "الخطوة 2: تسجيل الأصل البديل في الموقع نفسه",
  "Store": "مخزن",
  "Storeroom / Location": "المخزن / الموقع",
  "Storerooms": "المخازن",
  "Strict Blind Recount Mode": "وضع إعادة العد الأعمى الصارم",
  "Submit Work Order": "إرسال أمر العمل",
  "Successor": "الأصل البديل",
  "Successor Item Name": "اسم الصنف البديل",
  "Supplier": "المورد",
  "Supplier / Vendor": "المورد / البائع",
  "Symptoms, unusual noise, leaking, etc...": "الأعراض، ضجيج غير معتاد، تسرب، إلخ...",
  "Tag (e.g. AST-MIA-0081)": "الوسم (مثل AST-MIA-0081)",
  "Tag:": "الوسم:",
  "Target Asset": "الأصل المستهدف",
  "Target Asset:": "الأصل المستهدف:",
  "Task": "المهمة",
  "Task Description": "وصف المهمة",
  "Task {task} open": "المهمة {task} مفتوحة",
  "Team": "الفريق",
  "Team members (field mobile lists)": "أعضاء الفريق (قوائم الجوال الميدانية)",
  "Technician": "الفني",
  "Technician Labor Hours": "ساعات عمل الفني",
  "Technician Resolution Remarks": "ملاحظات الفني حول المعالجة",
  "The Repair Record and cost are created when {system} reports the approved charge.": "يُنشأ سجل الإصلاح وتكلفته عندما يُبلغ {system} عن الرسوم المعتمدة.",
  "The approved cost has not arrived yet, so this repair cannot be completed.": "لم تصل التكلفة المعتمدة بعد، لذا لا يمكن إكمال هذا الإصلاح.",
  "The completion date cannot be in the future": "لا يمكن أن يكون تاريخ الإكمال في المستقبل",
  "The first due date cannot be in the past": "لا يمكن أن يكون تاريخ الاستحقاق الأول في الماضي",
  "The last done date cannot be in the future": "لا يمكن أن يكون تاريخ آخر تنفيذ في المستقبل",
  "The next due date is counted from here (today when left empty).": "يُحتسب تاريخ الاستحقاق التالي من هنا (من اليوم إذا تُرك فارغًا).",
  "Third-Party Contractor Invoice ({currency})": "فاتورة مقاول خارجي ({currency})",
  "This property is linked to": "هذا العقار مرتبط بـ",
  "This property uses": "يستخدم هذا العقار",
  "Threshold {amount}.": "الحد {amount}.",
  "Ticket": "التذكرة",
  "Timestamped & stamped in asset registry": "مختومة بالوقت ومعتمدة في سجل الأصول",
  "Total Repair Cost:": "إجمالي تكلفة الإصلاح:",
  "Unassigned": "غير معيّن",
  "Under investigation": "قيد التحقيق",
  "Under-par": "أقل من المستوى القياسي",
  "Unit": "الوحدة",
  "Up to {n} photos (JPEG, PNG or WebP, 5 MB each).": "حتى {n} صور (JPEG أو PNG أو WebP، بحد 5 ميغابايت لكل صورة).",
  "Update Location to Found Room": "تحديث الموقع إلى الغرفة التي وُجد فيها",
  "Urgent": "عاجلة",
  "Urgent (immediate guest impact)": "عاجلة (تأثير فوري على النزلاء)",
  "Valid (Expires {date})": "ساري (ينتهي في {date})",
  "Value (AED)": "القيمة (درهم)",
  "Variance %": "نسبة الفرق %",
  "Variance Count": "عدد الفرق",
  "Variance Report": "تقرير الفروقات",
  "Variance Type": "نوع الفرق",
  "Via linked system": "عبر النظام المرتبط",
  "View only": "عرض فقط",
  "View photo": "عرض الصورة",
  "Warranty Ends": "انتهاء الضمان",
  "Warranty Expiry": "انتهاء الضمان",
  "Warranty Expiry Alerts": "تنبيهات انتهاء الضمان",
  "Warranty Status": "حالة الضمان",
  "Warranty Terms": "شروط الضمان",
  "Weekly": "أسبوعيًا",
  "Weeks": "أسابيع",
  "Where": "الموقع",
  "Within {pct}% Par Tolerance": "ضمن تفاوت المستوى القياسي {pct}%",
  "Within {threshold} threshold": "ضمن حد {threshold}",
  "Work Order #": "رقم أمر العمل",
  "Workbench": "المنصة",
  "Workbench sections": "أقسام المنصة",
  "Write-off & File Police/Insurance": "الشطب وتقديم بلاغ للشرطة/التأمين",
  "Write-off awaiting Finance approval": "الشطب بانتظار اعتماد المالية",
  "Write-off for {tag} (NBV {nbv}) approved - within the {threshold} Book Policy threshold.": "تم اعتماد شطب {tag} (صافي القيمة الدفترية {nbv}) - ضمن حد السياسة الدفترية {threshold}.",
  "Write-off for {tag} (NBV {nbv}) exceeds the {threshold} Book Policy threshold and was routed to the Finance Controller for sign-off.": "شطب {tag} (صافي القيمة الدفترية {nbv}) يتجاوز حد السياسة الدفترية {threshold} وأُحيل إلى المراقب المالي للاعتماد.",
  "Write-off for {tag} approved by Finance Controller.": "اعتمد المراقب المالي شطب {tag}.",
  "Write-off for {tag} rejected by Finance Controller.": "رفض المراقب المالي شطب {tag}.",
  "Write-off of": "شطب",
  "Write-off rejected": "رُفض الشطب",
  "Write-offs above the Category Book Policy threshold ({threshold}) need Finance Controller sign-off": "عمليات الشطب التي تتجاوز حد السياسة الدفترية للفئة ({threshold}) تتطلب اعتماد المراقب المالي",
  "Written off - needs Finance approval above the policy threshold": "مشطوب - يتطلب اعتماد المالية فوق حد السياسة",
  "Your role cannot report defects": "لا يمكن لدورك الإبلاغ عن الأعطال",
  "Zones (buildings / wings)": "المناطق (المباني / الأجنحة)",
  "and needs your dual sign-off.": "ويتطلب اعتمادك المزدوج.",
  "applies to all {n} asset(s) here": "ينطبق على جميع الأصول ({n}) هنا",
  "belongs to {location}": "يتبع {location}",
  "by {name}": "بواسطة {name}",
  "calendar by {date}": "حسب التقويم بحلول {date}",
  "capitalised": "مرسمل",
  "change": "تغيير",
  "completed": "مكتمل",
  "cost not yet recorded": "لم تُسجَّل التكلفة بعد",
  "cycles": "دورات",
  "damaged": "تالف",
  "disposed": "مستبعد",
  "due {date}": "مستحق في {date}",
  "e.g. Minibar compressor failing to cool": "مثال: ضاغط الميني بار لا يبرّد",
  "exceeds the Category Book Policy threshold of": "يتجاوز حد السياسة الدفترية للفئة البالغ",
  "expensed": "مصروف",
  "fair": "مقبول",
  "flagged as life-extending": "محدد كإصلاح يطيل العمر",
  "for": "لـ",
  "gain": "ربح",
  "good": "جيد",
  "hours": "ساعات",
  "hrs @": "ساعة بسعر",
  "in_service": "في الخدمة",
  "into service": "إلى الخدمة",
  "line": "بند",
  "lines": "بنود",
  "logged today": "سُجّلت اليوم",
  "loss": "خسارة",
  "misplaced": "في غير موقعه",
  "missing": "مفقود",
  "new": "جديد",
  "no reading yet": "لا توجد قراءة بعد",
  "not enough readings": "قراءات غير كافية",
  "not life-extending": "لا يطيل العمر",
  "now": "الآن",
  "on disposal:": "عند الاستبعاد:",
  "open incident": "حادثة مفتوحة",
  "overdue": "متأخر",
  "pending": "معلّق",
  "pending_disposal": "بانتظار الاستبعاد",
  "poor": "سيئ",
  "read {date}": "قُرئ في {date}",
  "registered": "مسجّل",
  "remove": "إزالة",
  "sent to": "أُرسلت إلى",
  "tag {code}": "الوسم {code}",
  "task": "مهمة",
  "tasks": "مهام",
  "ticket": "تذكرة",
  "tickets": "تذاكر",
  "when assets are registered": "عند تسجيل الأصول",
  "with a net book value of": "بصافي قيمة دفترية قدرها",
  "{asset} was not located in {location}. Document what has been checked so far.": "لم يُعثر على {asset} في {location}. وثّق ما تم فحصه حتى الآن.",
  "{currency}/hr": "{currency}/ساعة",
  "{done} / {total} audited": "تم جرد {done} / {total}",
  "{done} of {total} audits done": "تم إنجاز {done} من {total} عملية جرد",
  "{field} must be zero or more": "يجب أن تكون قيمة {field} صفرًا أو أكثر",
  "{file} is larger than 5 MB": "حجم {file} أكبر من 5 ميغابايت",
  "{incident} reported: {tag} is in repair and Repair Record {repair} was created.": "تم الإبلاغ عن {incident}: الأصل {tag} قيد الإصلاح وأُنشئ سجل الإصلاح {repair}.",
  "{incident} reported: {tag} is in repair and the ticket was queued for sending to {system}.": "تم الإبلاغ عن {incident}: الأصل {tag} قيد الإصلاح ووُضعت التذكرة في قائمة الإرسال إلى {system}.",
  "{incident} reported: {tag} is in repair and the ticket was sent to {system}.": "تم الإبلاغ عن {incident}: الأصل {tag} قيد الإصلاح وأُرسلت التذكرة إلى {system}.",
  "{incident} resolved; {tag} returned to service.": "تمت معالجة {incident}؛ وأُعيد {tag} إلى الخدمة.",
  "{item}: count of {count} accepted; book balance adjusted ({pct}% variance).": "{item}: قُبل العد {count}؛ وعُدّل الرصيد الدفتري (فرق {pct}%).",
  "{item}: resolved as {resolution}.": "{item}: عولج كـ {resolution}.",
  "{item}: write-off submitted and waiting for Finance Controller approval.": "{item}: أُرسل الشطب وهو بانتظار اعتماد المراقب المالي.",
  "{item}: {pct}% variance exceeds the {tolerance}% tolerance; held for investigation, stock not adjusted.": "{item}: الفرق {pct}% يتجاوز التفاوت المسموح {tolerance}%؛ عُلّق للتحقيق دون تعديل المخزون.",
  "{name} ({sku}) - all {n} asset(s)": "{name} ({sku}) - جميع الأصول ({n})",
  "{n} Breaches": "{n} تجاوزات",
  "{n} Damaged Assets:": "{n} أصول تالفة:",
  "{n} Expiring": "{n} على وشك الانتهاء",
  "{n} Misplaced Assets:": "{n} أصول في غير موقعها:",
  "{n} Missing Assets:": "{n} أصول مفقودة:",
  "{n} Units": "{n} وحدات",
  "{n} Verified Assets:": "{n} أصول مطابقة:",
  "{n} asset has warranties expiring within 60 days. File warranty claims before lapse!": "{n} أصل ينتهي ضمانه خلال 60 يومًا. قدّم مطالبات الضمان قبل انتهائه!",
  "{n} assets have warranties expiring within 60 days. File warranty claims before lapse!": "{n} أصول ينتهي ضمانها خلال 60 يومًا. قدّم مطالبات الضمان قبل انتهائها!",
  "{n} days": "{n} يومًا",
  "{n} discrepancies are still unresolved and block finalization.": "لا تزال {n} فروقات دون معالجة وتمنع الإنهاء.",
  "{n} low-value items approved for write-off.": "تم اعتماد شطب {n} بنود منخفضة القيمة.",
  "{n} member(s)": "{n} عضو",
  "{n} misplaced assets re-assigned in the asset registry with audit timestamps.": "أُعيد تعيين {n} أصول كانت في غير موقعها في سجل الأصول مع أختام وقت الجرد.",
  "{n} overdue": "{n} متأخرة",
  "{n} repair record": "{n} سجل إصلاح",
  "{n} repair records": "{n} سجلات إصلاح",
  "{pct}% Compliance": "امتثال {pct}%",
  "{repair} completed: total {total}, {classification}; {tag} is back in service (condition {condition}).": "اكتمل {repair}: الإجمالي {total}، {classification}؛ وعاد {tag} إلى الخدمة (الحالة {condition}).",
  "{replacement} dismissed; {tag} is unchanged.": "تم رفض {replacement}؛ ولم يتغير {tag}.",
  "{replacement} submitted: disposal {disposal} for {tag} awaits Department Head endorsement and Finance Controller approval. The successor is registered in {location} once it is approved.": "تم إرسال {replacement}: الاستبعاد {disposal} للأصل {tag} بانتظار مصادقة رئيس القسم واعتماد المراقب المالي. يُسجَّل الأصل البديل في {location} فور الاعتماد.",
  "{schedule} - cycle #{n} locations ({done} / {total} audited)": "{schedule} - مواقع الدورة #{n} (تم جرد {done} / {total})",
  "{system} Connected:": "{system} متصل:",
  "{system} Connected: outbound defect webhooks enabled. Inbound ticket sync updates repair records. Native repair cost entry disabled (zero double-counting).": "{system} متصل: خطافات الويب الصادرة للأعطال مفعّلة. مزامنة التذاكر الواردة تحدّث سجلات الإصلاح. إدخال تكلفة الإصلاح الداخلي معطّل (دون احتساب مزدوج).",
  "{tag} relocated to {location}. Asset location updated in the register.": "نُقل {tag} إلى {location}. تم تحديث موقع الأصل في السجل.",
  "{tag} will be physically returned to {location}.": "سيُعاد {tag} فعليًا إلى {location}.",
  "{task} completed; next PM due {due}.": "اكتملت {task}؛ الصيانة الوقائية التالية مستحقة في {due}.",
  "{total} of approved and pending write-offs posts to GL shrinkage account": "يُرحَّل {total} من عمليات الشطب المعتمدة والمعلّقة إلى حساب الفاقد في دفتر الأستاذ العام",
};
